import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { responsiveFieldStyle } from '../form-field.styles'

export { fieldRoot as root, fieldFocused as focused, fieldError as error } from '../form-field.styles'

export const borderLess = css`
  border: none;
  box-shadow: none;
`

export const input = (theme: Theme) => css`
  padding: 0;
  min-width: 0;
  width: 100%;
  color: ${theme.palette.text.title};
  caret-color: ${theme.presentation.field.caretColor};
  border: none;
  background-color: transparent;

  &[type='number'] { -moz-appearance: textfield; }
  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='password'] { letter-spacing: 8px; }

  &::placeholder, &.empty {
    color: ${theme.palette.text.emptyState};
    font-weight: ${theme.presentation.field.placeholderWeight};
  }
  &:disabled {
    opacity: 1; /* required on iOS */
    -webkit-text-fill-color: ${theme.presentation.field.disabledColor};
    color: ${theme.presentation.field.disabledColor};
  }
  &:disabled::placeholder { color: ${theme.presentation.field.disabledColor}; }
`

export const typographyStyles = (theme: Theme) =>
  responsiveFieldStyle(theme.presentation.field.value)

export const adornment = (theme: Theme, disabled: boolean) => css`
  color: ${disabled ? theme.presentation.field.disabledAdornmentColor : theme.presentation.field.adornmentColor};
`
export const startAdornment = (theme: Theme) => css`
  margin-right: ${theme.spacing[8]};
`
export const endAdornment = (theme: Theme) => css`
  margin-left: ${theme.spacing[8]};
`
